import React, { Component } from 'react';

var Time = React.createClass({
  getInitialState: function(){
    return {
      date: new Date()
    }
  },
  componentDidMount: function(){
    var now = new Date(),
        diff,
        _THIS = this,
        tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() + 1);

    diff = tomorrow - now;

    this.timer = setTimeout(function(){
      _THIS.setState({
        date: new Date()
      })
    }, diff);
  },
  componentDidUpdate: function(){
    var _THIS = this;
    window.clearTimeout(this.timer2);
    this.timer2 = setTimeout(function(){
      _THIS.setState({
        date: new Date()
      })
    }, 60000);
  },
  render: function(){

    var date = this.state.date,
        hours = String(date.getHours()).length == 1 ? '0' + date.getHours() : date.getHours(),
        minutes = String(date.getMinutes()).length == 1 ? '0' + date.getMinutes() : date.getMinutes();

    return(
      <div className="time">
        <span>{hours}</span><span className="second"> : </span><span>{minutes}</span>
      </div>
    );
  },
  componentWillUnmount: function(){
    window.clearTimeout(this.timer);
    window.clearTimeout(this.timer2);
    this.timer = false;
    this.timer2 = false;
  }
});

export default Time;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/Time/index.jsx
 **/